module.exports = __webpack_public_path__ + "static/media/08.8e0771fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/08.jpg
// module id = 377
// module chunks = 0